var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.933 10a1.099 1.099 0 0 0 .22 1.213l.04.04a1.335 1.335 0 1 1-1.886 1.886l-.04-.04a1.101 1.101 0 0 0-1.214-.22 1.1 1.1 0 0 0-.666 1.007v.113a1.333 1.333 0 1 1-2.667 0v-.06A1.1 1.1 0 0 0 6 12.933a1.1 1.1 0 0 0-1.213.22l-.04.04a1.333 1.333 0 1 1-1.887-1.887l.04-.04a1.1 1.1 0 0 0 .22-1.213 1.1 1.1 0 0 0-1.007-.667H2a1.333 1.333 0 0 1 0-2.667h.06A1.1 1.1 0 0 0 3.067 6a1.1 1.1 0 0 0-.22-1.213l-.04-.04a1.334 1.334 0 1 1 1.886-1.887l.04.04a1.1 1.1 0 0 0 1.214.22H6a1.1 1.1 0 0 0 .667-1.006v-.114a1.333 1.333 0 1 1 2.666 0v.06A1.1 1.1 0 0 0 10 3.066a1.1 1.1 0 0 0 1.213-.22l.04-.04a1.332 1.332 0 0 1 2.278.943 1.333 1.333 0 0 1-.391.944l-.04.04a1.1 1.1 0 0 0-.22 1.213v.053a1.1 1.1 0 0 0 1.007.667H14a1.333 1.333 0 1 1 0 2.667h-.06a1.1 1.1 0 0 0-1.007.666Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSettings;